import AbstractModule from './AbstractModule';

export class Slider extends AbstractModule {
    constructor (target) {
        console.log('Module: Slider has been loaded');

        super(target);

        this.initSlick();
    }

    initSlick () {
        this.$el.slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnHover:false,

            arrows: false,
            dots: true,
            speed: 600,
            autoplay: true,
            fade: false,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
        });
    }

    destroy () {
        this.$el.off();
    }
}


// WEBPACK FOOTER //
// ./app/src/js/modules/Slider.js